<template>
    <section class="app-main">
        <div class="app-main-content flex justify-start">
            <div class="left flex justify-center items-center text-gray-200 text-lg font-bold">
                <div class="flex justify-center flex-col items-center" v-if="name === 'my:collection'">
                    <img class="w-12" src="@/assets/images/-layout/icon/collect.png" alt="" />
                    <div class="mt-2.5">我 的 收 藏</div>
                </div>
                <div class="flex justify-center flex-col items-center" v-if="name === 'special:answer'">
                    <img class="w-12" src="@/assets/images/-layout/icon/question.png" alt="" />
                    <div class="mt-2.5 ">答 案 解 析</div>
                </div>
                <div class="flex justify-center flex-col items-center" v-if="name === 'my:feedback'">
                    <img class="w-12" src="@/assets/images/-layout/icon/question.png" alt="" />
                    <div class="mt-2.5">答 疑 记 录</div>
                </div>
            </div>
            <div class="main">
                <router-view v-slot="{ Component }">
                    <transition name="fade-transform" mode="out-in">
                        <component :is="Component"></component>
                    </transition>
                </router-view>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            name: '',
        }
    },
    computed: {},
    watch: {
        $route: {
            deep: true,

            handler(route) {
                this.name = (route.meta && route.meta.name) || ''
            },

            immediate: true,
        },
    },
    methods: {},
    created() {
    },
    mounted() {
    },
}
</script>

<style lang="less" scoped>
.app-main {
    height: calc(100vh - 86px);
    background-image: url('../../assets/images/-layout/bg-main.png');
    background-position: 50% 100%;
    background-repeat: no-repeat;
    min-height: 630px;
    width: 100%;
}

.app-main-content {
    width: 100%;
    height: 100%;
    position: relative;
}

.left {
    width: 148px;
    height: 100%;
    background-image: url('../../assets/images/-layout/bg-side_long.png');
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    flex: none;
}

.main {
    height: 100%;
    width: 100%;
    margin-left: 15px;
}
</style>
